// External Dependencies:
import { browserHistory } from 'react-router'
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import zenscroll from 'zenscroll'

// Internal Dependencies:
import { doRequest } from 'utilities/request'

// Events:
const pageChanged = document.createEvent( 'Event' )
pageChanged.initEvent( 'sitePageChanged', true, true )

/******************************************************************************
	Forum
/*****************************************************************************/

export function requestForumData( slug, requestOnly ) {
	return {
		type: 'REQUEST_FORUM_DATA',
		payload: {
			slug: slug,
			requestOnly: requestOnly
		}
	}
}

export function receiveForumData( slug, json ) {
	return {
		type: 'RECEIVE_FORUM_DATA',
		payload: {
			slug: slug,
			data: json
		}
	}
}

export function setCurrentForum( slug ) {
	return {
		type: 'SET_CURRENT_FORUM',
		payload: slug
	}
}

// export function setCurrentForumPost( slug ) {
// 	return {
// 		type: 'SET_CURRENT_FORUM_POST',
// 		payload: slug
// 	}
// }

export function getForumData( slug, archivePageNumber = false, requestOnly = false ) {
	return function( dispatch, getState ) {
		const { forumById, forumLoadingById } = getState().forum
		const { locale } = getState().site

		// Normalise slug, removing /
		slug = slug.replace( /\//g, '' )

		// Don't load the same thing simultaneously:
		if ( forumLoadingById[ 'id_' + slug ] ) {
			return
		}

		// Short circuit for existing data:
		if ( forumById[ 'id_' + slug ] ) {
			if ( ! requestOnly && 'all' != slug ) {
				dispatch( setCurrentForum( slug ) )
			}

			return
		}

		dispatch( requestForumData( slug, requestOnly ) )

		if ( ! requestOnly ) {
			dispatch( showLoading() )
		}

		const url = siteData.api_base_url + 'forum?slug=' + slug + '&page_number=' + archivePageNumber + '&locale=' + locale

		return doRequest( url, {
			credentials: 'include',
			headers: {
				'X-WP-Nonce': siteData.wp_rest_nonce
			}
		})
			.then( json => {
				if ( 'all' == slug ) {
					Object.keys( json ).forEach( i => {
						dispatch( receiveForumData( i, json[ i ] ) )
					} )
				} else {
					dispatch( receiveForumData( slug, json ) )
				}

				if ( ! requestOnly ) {
					dispatch( hideLoading() )
				}

				if ( ! requestOnly && 'all' != slug ) {
					dispatch( setCurrentForum( slug ) )
				}
			})
			.catch( error => {
				console.log( error, 'error' );
			})
	}
}

/******************************************************************************
	Topic
/*****************************************************************************/

export function requestForumTopicData( slug, requestOnly ) {
	return {
		type: 'REQUEST_FORUM_TOPIC_DATA',
		payload: {
			slug: slug,
			requestOnly: requestOnly
		}
	}
}

export function receiveForumTopicData( slug, json, requestOnly = false ) {
	return {
		type: 'RECEIVE_FORUM_TOPIC_DATA',
		payload: {
			slug: slug,
			data: json,
			requestOnly: requestOnly
		}
	}
}

export function setCurrentForumTopic( slug ) {
	return {
		type: 'SET_CURRENT_FORUM_TOPIC',
		payload: slug
	}
}

export function getForumTopicData( slug, archivePageNumber = false, requestOnly = false ) {
	return function( dispatch, getState ) {
		const { selected, topicById, topicLoadingById } = getState().forum
		const { locale } = getState().site

		// Normalise slug, removing /
		slug = slug.replace( /\//g, '' )

		// Don't load the same thing simultaneously:
		if ( topicLoadingById[ 'id_' + slug ] ) {
			return
		}

		dispatch( requestForumTopicData( slug, requestOnly ) )

		if ( ! requestOnly ) {
			dispatch( showLoading() )
		}

		const url = siteData.api_base_url + 'forum-topic?slug=' + slug + '&page_number=' + archivePageNumber + '&locale=' + locale + '&forum_id=' + selected.id

		return doRequest( url, {
			credentials: 'include',
			headers: {
				'X-WP-Nonce': siteData.wp_rest_nonce
			}
		})
			.then( json => {
				if ( 'all' == slug ) {
					Object.keys( json ).forEach( i => {
						dispatch( receiveForumTopicData( i, json[ i ], requestOnly ) )
					} )
				} else {
					dispatch( receiveForumTopicData( slug, json, requestOnly ) )
				}

				if ( ! requestOnly ) {
					dispatch( hideLoading() )
					dispatch( setCurrentForumTopic( slug ) )
				}
			})
			.catch( error => {
				console.log( error, 'error' );
			})
	}
}

export function addReply( id, content, dateIso, authorName ) {
	return {
		type: 'ADD_FORUM_REPLY',
		payload: {
			id: id,
			content: content,
			dateIso: dateIso,
			authorName: authorName
		}
	}
}

export function sendReply( content ) {
	return function( dispatch, getState ) {
		const { selected, selectedTopic } = getState().forum
		const { locale } = getState().site

		dispatch( showLoading() )

		const url = siteData.api_base_url + 'forum-reply'
		const data = {
			forum_id: selected.id,
			topic_id: selectedTopic.id,
			content: content
		}

		return doRequest( url, {
			method: 'PUT',
			credentials: 'include',
			headers: {
				'X-WP-Nonce': siteData.wp_rest_nonce,
				'Content-type': 'application/json'
			},
			body: JSON.stringify( data )
		})
			.then( json => {
				dispatch( hideLoading() )
				dispatch( addReply( json.id, json.content, json.date_iso, json.author_name ) )

				var newReplyDiv = document.querySelector( `#reply-${json.id}` )

				if ( newReplyDiv ) {
					zenscroll.center( newReplyDiv )
					newReplyDiv.classList.add( 'is-new' )
				} else {
					setTimeout( () => {
						newReplyDiv = document.querySelector( `#reply-${json.id}` )
						newReplyDiv.classList.add( 'is-new' )

						zenscroll.center( newReplyDiv )
					}, 500 )
				}
			})
			.catch( error => {
				console.log( error, 'error' );
			})
	}
}

export function addLike( id, liked ) {
	return {
		type: 'ADD_FORUM_REPLY_LIKE',
		payload: {
			id: id,
			liked: liked
		}
	}
}

export function sendLike( replyId, liked ) {
	return function( dispatch, getState ) {
		const { selected } = getState().forum
		const url = siteData.api_base_url + 'forum-reply-like'
		const data = {
			forum_id: selected.id,
			reply_id: replyId,
			liked: liked
		}

		return doRequest( url, {
			method: 'PUT',
			credentials: 'include',
			headers: {
				'X-WP-Nonce': siteData.wp_rest_nonce,
				'Content-type': 'application/json'
			},
			body: JSON.stringify( data )
		})
			.then( json => {
				dispatch( addLike( replyId, liked ) )
			})
			.catch( error => {
				console.log( error, 'error' );
			})
	}
}

export function setNewRepliesNoticeAsSeen() {
	return {
		type: 'SET_NEW_REPLIES_NOTICE_AS_SEEN'
	}
}

/******************************************************************************
	Create Topic
/*****************************************************************************/

// export function addTopic( data ) {
// 	return {
// 		type: 'ADD_FORUM_TOPIC',
// 		payload: data
// 	}
// }

export function createTopic( title, content, privacy, users ) {
	return function( dispatch, getState ) {
		const { selected } = getState().forum
		const url = siteData.api_base_url + 'forum-topic'
		const data = {
			forum_id: selected.id,
			title: title,
			content: content,
			privacy: privacy,
			users_emails: users
		}

		return doRequest( url, {
			method: 'POST',
			credentials: 'include',
			headers: {
				'X-WP-Nonce': siteData.wp_rest_nonce,
				'Content-type': 'application/json'
			},
			body: JSON.stringify( data )
		})
			.then( json => {
				dispatch( receiveForumTopicData( json.slug, json ) )
				dispatch( setCurrentForumTopic( json.slug ) )

				// Update url:
				window.history.pushState( null, null, `/forum/${selected.slug}/${json.slug}` )
				window.dispatchEvent( pageChanged )
			})
			.catch( error => {
				console.log( error, 'error' );
			})
	}
}



// WEBPACK FOOTER //
// ./redux/actions/forum.jsx